import {Component, Input, OnInit} from '@angular/core';
import {ActivatedRoute, NavigationEnd, Params, PRIMARY_OUTLET, Router} from '@angular/router';
import {KvItem} from './modules/core/models/kv-item';
import {Title} from '@angular/platform-browser';

interface IBreadcrumb {
  label: string;
  title: string;
  params?: Params;
  url: string;
}

@Component({
  selector: 'dandp-breadcrumb',
  template: `
  <div id="breadcrumbTrail">
			    You are here:
    <div class="breadcrumbs">
      <span>
        <a routerLink="/" class="breadcrumb-link">Home</a>
        <i *ngIf="breadcrumbs && breadcrumbs.length > 0" class="fa fa-chevron-right breadcrumb-separator"></i>
      </span>
      <span *ngFor="let bc of breadcrumbs; let i = index">
        <a class="breadcrumb-link"
           [routerLink]="[bc.url]">{{bc.label}}</a>
        <i *ngIf="i !== breadcrumbs.length - 1 && bc.label" class="fa fa-chevron-right breadcrumb-separator"></i>
      </span>
    </div>
  </div>
  <h1 id="headlineBar">{{pageName}}</h1>
  <hr />
  `,
  styles: [`
    .breadcrumbs {
      font-size: .9em;
      margin-right:0px;
      margin-left:auto;
      display:inline-block;
    }
    .breadcrumb-link {
      display: inline-block;
      padding-top: inherit;
      padding-bottom: inherit;
      padding-left: 4px;
      padding-right: 4px;
    }
    .breadcrumb-separator {
      color:#666;
    }
  `]
})
export class DandPBreadcrumbComponent implements OnInit {
  public breadcrumbs: any[];
  public pageName: string;

  constructor(private activatedRoute: ActivatedRoute,
              private router: Router,
              private title: Title) { }

  ngOnInit() {

    this.router.events.filter(event => event instanceof NavigationEnd).subscribe(event => {

      const root: ActivatedRoute = this.activatedRoute.root;
      this.breadcrumbs = this.getBreadcrumbs(root, '', []);
      const lastItem = this.breadcrumbs.slice(-1)[0];
      if (lastItem) {
        this.pageName = lastItem['title'];
      } else {
        this.pageName = 'Home';
      }
      this.title.setTitle('BARC Information Repository/Administrative Record -- ' + this.pageName);
    });
  }

  private getBreadcrumbs(route: ActivatedRoute, url: string = '', breadcrumbs: IBreadcrumb[] = []): IBreadcrumb[] {
      const ROUTE_DATA_BREADCRUMB = 'breadcrumb';

      const children: ActivatedRoute[] = route.children;

      // return if there are no more children
      if (children.length === 0) {
        return breadcrumbs.filter(bc => bc.label && bc.label.length > 0);
      }

      // iterate over each children
      for (const child of children) {
        // verify primary route
        if (child.outlet !== PRIMARY_OUTLET) {
          continue;
        }

        // verify the custom data property "breadcrumb" is specified on the route
        if (!child.snapshot.data.hasOwnProperty(ROUTE_DATA_BREADCRUMB)) {
          return this.getBreadcrumbs(child, url, breadcrumbs);
        }

        // get the route's URL segment
        const routeURL: string = child.snapshot.url.map(segment => segment.path).join('/');

        // append route URL to URL
        url += `/${routeURL}`;

        // add breadcrumb
        const breadcrumb: IBreadcrumb = {
          label: child.snapshot.data[ROUTE_DATA_BREADCRUMB],
          title: child.snapshot.data['title'],
          params: child.snapshot.params,
          url: url
        };
        breadcrumbs.push(breadcrumb);

        // recursive
        return this.getBreadcrumbs(child, url, breadcrumbs);
      }

      // we should never get here, but just in case
      return breadcrumbs;
    }
}



// WEBPACK FOOTER //
// C:/Users/jstan/Projects/usda-document-client/src/app/app-breadcrumb.ts